import moment from "moment";

/*
roleObj properties:
  - username
  - value
  - startDate
 */
class Role {
  /**
   *
   * @param {object} roleObj
   * @param {string} username
   */
  constructor(roleObj, username) {
    this.obj = null;

    if (roleObj) {
      this.obj = roleObj;
      this.obj.username = username;
    }
  }

  /**
   *
   * @returns {Date}
   */
  getStartDate() {
    return moment(this.obj.startDate).toDate();
  }

  /**
   *
   * @returns {boolean}
   */
  hasLoaded() {
    return !!this.obj;
  }
}

export default Role;
